import BlazeSlider from 'blaze-slider'
import 'blaze-slider/dist/blaze.css'

const handleControls = (el, numSlides) => {
  const controls = el.querySelector('.blaze-slider-controls')

  if (controls) {
    controls.classList.remove('invisible')

    if (window.matchMedia('(min-width: 1024px)').matches) {
      if (numSlides < 4) {
        controls.classList.add('invisible')
        return
      }
    }

    if (window.matchMedia('(min-width: 1280px)').matches) {
      if (numSlides < 5) {
        controls.classList.add('invisible')
      }
    }
  }
}

document.querySelectorAll('.element-resourceslider').forEach((el) => {
  const slider = el.querySelector('.blaze-slider')
  const numSlides = slider.querySelectorAll('.blaze-slide').length

  if (numSlides > 1) {
    let opts = {
      all: {
        slideGap: '4px',
      },
      '(min-width: 768px)': {
        slidesToShow: 2,
      },
    }

    if (numSlides > 2) {
      opts = {
        ...opts,
        '(min-width: 1024px)': {
          slidesToShow: 3,
        },
      }
    }

    if (numSlides > 3) {
      opts = {
        ...opts,
        '(min-width: 1280px)': {
          slidesToShow: 4,
        },
      }
    }

    new BlazeSlider(slider, opts)
  }

  handleControls(el, numSlides)
})
